import React from 'react';
import $ from 'jquery';


const AlertModal = ({ title, message,type,First_Callback,Second_Callback }) => { 
return (
    <div>
        <button type="button" id="Show_ArletModal" style={{display:"none"}} className="Primary mg-b-10" href="#" data-toggle="modal" data-target="#Alert-Modal" >Primary</button>
        <div id="Alert-Modal" className="modal fade" tabIndex="-1" role="dialog" aria-labelledby="addappTitle" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document" >
                <div className="modal-content">

                    <div className="modal-header">
                        <div className="ModalTopClose_btn"><span style={{cursor:"pointer"}} id="CloseAlertModal" data-dismiss="modal" aria-hidden="true">x</span></div>
                        <h5 className="modal-title" style={{fontSize:"17px",fontWeight:"700"}}>{title}</h5>
                        {/* <i className="fa fa-times-circle appointmentdetailcross" id="CloseAlertModal" data-dismiss="modal" aria-hidden="true"></i> */}
                    </div>

                    <div className="modal-body">
        
                        <div className="" style={{padding:"0px 15px",fontSize:"16px"}}>
                            <div className="col-md-12">
                                {message}
                            </div> 
                        </div>
        
                        <div style={{float:"right",marginRight:"15px",marginTop:"35px"}}>
                            <button hidden={ type !== 1 } onClick={First_Callback} type="button" className="btn btn_style1" >Yes</button>
                            <button hidden={ type !== 1 } onClick={Second_Callback} type="button" className="btn btn_style2"  >No </button>
                            <button hidden={ type !== 2 } onClick={First_Callback} type="button" className="btn btn_style1" >Ok</button>
                            <button style={{display:"none"}} type="button" id="Generic-modal-CloseBtn" data-dismiss="modal">Close</button>
                        </div>
        
                    </div>
        
                </div>
            </div>
        </div>
    </div>
)}

AlertModal.defaultProps = {
   title: "Alert",
   messahe: "",
   onClose: () => { },
   showSubmit: false,
}
export default AlertModal;